import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ISRMSelectedQuestionAndAnswer } from '../../../core/models/srm.model';
import { QuickbetSelectionComponent } from '../quickbetSelection/quickbet-selection.component';

@Component({
    selector: 'quickbet-partial-overlay-selection',
    templateUrl: 'quickbet-partial-overlay-selection.component.html',
    styleUrls: ['quickbet-partial-overlay-selection.component.scss'],
    standalone: false,
})
export class QuickbetPartialOverlaySelectionComponent extends QuickbetSelectionComponent {
    @Input() override isQuickBet: boolean;
    @Input() isSRMBet: boolean;
    @Input() selectedQuestionAndAnswers?: ISRMSelectedQuestionAndAnswer[];
    @Input() srmOdds: string;
    @Output() readonly openFullOverlayFn: EventEmitter<void> = new EventEmitter();
    @Output() override readonly removeSelectionFn: EventEmitter<void> = new EventEmitter();

    openFullOverlay($event: MouseEvent): void {
        $event.preventDefault();

        // close native navigation panel (prev, next, done) opened on focus
        ($event.target as HTMLElement).blur();
        this.sessionStorageService.set('fromPartialOverlay', true);

        this.openFullOverlayFn.emit();
    }

    override removeSelection(): void {
        this.pubsub.publish(this.pubsub.API.ODDS_BOOST_CHANGE, false);
        this.removeSelectionFn.emit();
    }
}
